import { Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Flex, Typography } from "antd"
import classNames from "classnames"

import uiStore from "@src/app/uiStore"
import css from "@src/pages/statusConfirmation/index.module.css"

type Props = {
  email?: string
}
export const TryTestEnvironment = observer(({ email }: Props) => {
  const { isTransferioTheme } = uiStore()

  return (
    <Flex
      className={classNames([
        css.tryTestWrap,
        { [`${css.tryTestWrapTrans}`]: isTransferioTheme },
      ])}
      gap={16}
      vertical
    >
      <Typography.Title className={css.title} level={4}>
        TRY IT BEFORE YOU BUY IT
      </Typography.Title>

      <Flex gap={32} justify="flex-start" vertical>
        <Typography.Text className={css.subtitle}>
          Test drive {isTransferioTheme ? "our" : "Cryptix"} full platform –
          including the user-friendly dashboard and robust API – with{" "}
          <span>testnet</span> coins! Generate API keys in our test environment
          and get started today.
        </Typography.Text>

        <Link
          id="GENERATED_ID_TRYTESTENVIRONMENT_LINK_VOID_1"
          to={
            isTransferioTheme
              ? `https://dashboard.sandbox.transferio.io/signup?email=${email}`
              : `https://dashboard.sandbox.cryptix.io/signup?email=${email}`
          }
        >
          <Button
            id="GENERATED_ID_TRYTESTENVIRONMENT_BUTTON_TRY_TEST_ENVIRONMENT_1"
            size="large"
          >
            Try Test Environment
          </Button>
        </Link>
      </Flex>
    </Flex>
  )
})
